import { nanoid } from 'nanoid';

export function generateId() {
  return nanoid();
}

export function generateShortId(size: number = 10) {
  return nanoid(size);
}
